import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';

// Thin wrapper over the HQ-admin-only callable that provisions a tenant + its
// first Owner server-side (keeps the calling HQ admin's session intact).
export function adminCreateTenant(payload) {
  return httpsCallable(functions, 'adminCreateTenant')(payload).then((r) => r.data);
}
